import React, { useState, useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useTranslation } from 'react-i18next';

// Formulaire interne — doit être enfant de <Elements>
const StripeForm = ({ onSuccess, onError, buttonLabel }) => {
    const stripe = useStripe();
    const elements = useElements();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;
        setLoading(true);
        try {
            const { error, setupIntent } = await stripe.confirmSetup({
                elements,
                confirmParams: {},
                redirect: 'if_required',
            });
            if (error) {
                onError(error.message);
                setLoading(false);
            } else if (setupIntent && setupIntent.status === 'succeeded') {
                const pm = setupIntent.payment_method;
                onSuccess({
                    paymentMethodId:   typeof pm === 'string' ? pm : pm.id,
                    paymentMethodType: typeof pm === 'string' ? null : pm.type,
                });
                // Ne pas remettre loading à false — la page va changer
            }
        } catch (err) {
            onError(err.message);
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement options={{
                layout: { type: 'tabs', defaultCollapsed: false },
                paymentMethodOrder: ['card', 'sepa_debit'],
                terms: {
                    card: 'never',
                    sepaDebit: 'never',
                }
            }} />
            <button
                type="submit"
                className="ps-btn ps-btn--fullwidth ps-btn-dark ommp00"
                style={{ marginTop: '20px' }}
                disabled={!stripe || loading}
                onClick={loading ? (e) => e.preventDefault() : undefined}
            >
                {loading ? (
                    <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        {t('payment.processing')}
                    </>
                ) : (buttonLabel || t('payment.stripe_setup_title'))}
            </button>
        </form>
    );
};

// Composant exporté
const StripePaymentElement = ({ clientSecret, stripePublishableKey, onSuccess, onError, migrationMessage, buttonLabel }) => {
    // useMemo évite de recréer l'instance Stripe à chaque render
    const stripePromise = useMemo(() => loadStripe(stripePublishableKey), [stripePublishableKey]);

    const options = {
        clientSecret,
        paymentMethodCreation: 'manual',
        paymentMethodOrder: ['card', 'sepa_debit'],
    };

    return (
        <div>
            {migrationMessage && (
                <div className="alert alert-info stripe-migration-banner" style={{ marginBottom: '20px' }}>
                    <p style={{ margin: 0 }}>{migrationMessage}</p>
                </div>
            )}
            <Elements stripe={stripePromise} options={options}>
                <StripeForm onSuccess={onSuccess} onError={onError} buttonLabel={buttonLabel} />
            </Elements>
        </div>
    );
};

export default StripePaymentElement;
